/**
 * The one text-input class for the auth screens (signup, login, the credential
 * step). It used to be copy-pasted verbatim in three files; a single source keeps
 * the field height (44px), the 16px text (no iOS focus-zoom), and the teal focus
 * ring identical everywhere.
 */
export const INPUT_CLASS =
  'h-11 w-full rounded-md border-[1.5px] border-edge bg-bone px-3 text-[16px] text-ink outline-none transition-colors placeholder:text-ink-muted focus:border-brand focus:bg-bone-surface focus:shadow-[0_0_0_3px_rgba(10,92,92,0.1)]';
